import GaEvent from './GaEvent';

export default class NavItemClickedGaEvent extends GaEvent {
  constructor(path: string, name: string | undefined = undefined) {
    super('nav_item_clicked');

    this.addPathParam('item_path', path);
    this.addParam('item_name', name);
  }

  addHeaderNavigation() {
    return this.addPageSection('header_navigation');
  }

  addFooterNavigation() {
    return this.addPageSection('footer_navigation');
  }
}
